import { useNavigate } from 'react-router-dom';

// project imports
import { useAuth } from 'modules/auth/hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| OWNER GUARD ||============================== //

/**
 * Owner role guard for routes
 */
const OwnerGuard = ({ children }: GuardProps) => {
    const { isOwner } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isOwner) {
            navigate('login', { replace: true });
        }
    }, [isOwner, navigate]);

    return children;
};

export default OwnerGuard;
